export default __webpack_public_path__ + "static/media/BAL-USDT.18361453.svg";